import React, { useEffect, useState } from 'react';
import {
  Button,
  Select,
  Table,
  IconClipboard,
  InlineNotification,
  useToast
} from '@veneer/core';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { numberFormatCommaTwoFraction } from './../../../common/js/utils/numberFormat';
const ChannelRedeemStatements = (props) => {
  const configStatementColumns = [
    {
      id: 'monthFormatted',
      label: <Trans i18nKey='month' />,
    },
    {
      id: 'initialBalanceFormatted',
      label: <Trans i18nKey='initialbalance' />,
    },
    {
      id: 'finalBalanceFormatted',
      label: <Trans i18nKey='finalbalance' />,
    },
  ];

  const configDetailsColumns = [
    {
      id: 'dateFormatted',
      label: <Trans i18nKey='date' />,
    },
    {
      id: 'entry',
      label: <Trans i18nKey='entry' />,
    },
    {
      id: 'creditFormatted',
      label: <Trans i18nKey='credit' />,
    },
    {
      id: 'debitFormatted',
      label: <Trans i18nKey='debit' />,
    },
  ];

  const connectApi = new ConnectAPI();

  const [configSatement, setConfigStatement] = useState(configStatementColumns);
  const [configDetails, setConfigDetails] = useState(configDetailsColumns);
  const [order, setOrder] = useState(configSatement.map((c) => c.id));
  const [orderDetails, setOrderDetails] = useState(
    configDetails.map((c) => c.id)
  );
  const [orderBy, setOrderBy] = useState('month');
  const [orderByDetails, setOrderByDetails] = useState('date');
  const [orderType, setOrderType] = useState('descending');
  const [orderTypeDetails, setOrderTypeDetails] = useState('ascending');
  const [tableData, setTableData] = useState([]);
  const [tableDetailsData, setTableDetailsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDetailsPage, setCurrentDetailsPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [channelsView, setChannelsView] = useState([]);
  const [channelSelected, setChannelSelected] = useState('');
  const [showOrderInProgressAlert, setShowOrderInProgressAlert] = useState(false);
  const pageSize = 50;
  const { t } = useTranslation();
  const [nextId, setNextId] = useState(0);
  const { addToast } = useToast();

  useEffect(() => {
     //validate location
     let currentUser = JSON.parse(localStorage.getItem("currentUser"));
     let validate=false;
     currentUser.urls.forEach(ur=>{
       if (ur==window.location.pathname){
         validate=true;
       }
     });
     if (validate==false){
       const { history } = props;
         history.push({
           pathname: '/' 
         });
     }
     //end validate
    const fetchData = () => {
      connectApi
        .get(
          'api/Channels',
          {
            params: {
              landingCost: true,
            },
          },
          ChannelsLoad
        )
        .catch((error) => {
          console.log(error);
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        });
    };
    const ChannelsLoad = (status, data) => {
      setChannelsView(
        data.map((item) => {
          return {
            value: item.idCustomer,
            label: item.name,
          };
        })
      );
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if ((currentUser.idRole == 10 || currentUser.idRole == 9) && data.length > 0) {
        setChannelSelected(data[0].idCustomer);
      }
    };
    fetchData();
  }, []);
  const handleRedeemCompensation = (index) => {
    setIsLoading(true);
    connectApi
      .get(
        'api/Channels/EnableToOrder',
        {
          params: {
            customerId: channelSelected,
            endUserId: channelSelected,
            series: 4,
          },
        },
        enableResponseLoad
      )
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        if (error?.response?.data.includes('An order is in progress')) {
          addToast({ id: nextId, type: 'warning', text: t('orderInProgressAlert'), timeout: 20 });
          setNextId(prev => prev + 1);
        } else {
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }
      });
  };

  const enableResponseLoad = (status, data) => {
    setIsLoading(false);
    const { history } = props;

    history.push({
      pathname: '/compensation/ChannelRedeem/' + channelSelected,
    });
  };
  const RenderChannelsList = () => {
    const handleSelectChange = (name) => (event) => {
      setChannelSelected(event.value);
    };
    return (
      <div
        style={{
          width: '350px',
          padding: '0.5% 2% ',
        }}
      >
        <Select
          name="channel"
          onChange={handleSelectChange()}
          //onSearch={handleSearchChange()}
          //onClear={handleClearChannel()}
          options={channelsView}
          placeholder={<Trans i18nKey="channels" />}
          showSearch={false}
          value={[channelSelected]}
        />
      </div>
    );
  };

  useEffect(() => {
    //console.log(channelSelected);
    const fetchData = () => {
      setIsLoading(true);

      //dataResponseLoad('400', DATALOCAL);
      connectApi
        .get(
          'api/Channels/' + channelSelected + '/compensationStatement',
          '',
          dataResponseLoad
        )
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      data.map((item, key) => {
        item.monthFormatted = (
          <a href={key} onClick={handleSelectMonth(item)}>
            {moment(item.month).format('MMM/YYYY')}
          </a>
        );
        //item.monthFormatted = moment(item.date).format('MMM/YYYY');
        item.initialBalanceFormatted =
          item.initialBalance == null
            ? ''
            : numberFormatCommaTwoFraction(item.initialBalance);
        item.finalBalanceFormatted =
          item.finalBalance == null
            ? ''
            : numberFormatCommaTwoFraction(item.finalBalance);
      });

      //setDataResponse(data === undefined ? [] : data);
      setTableData(data === undefined ? [] : data);
      //console.log(dataResponse);
      setIsLoading(false);
    };

    if (channelSelected != '') {
      fetchData();
    }
  }, [channelSelected]);
  const handleSelectDetail = (index) => (event) => {
    event.preventDefault();
    const { history } = props;
    history.push({
      pathname: '/cpp/report/statement/order/' + index.idOrder,
      data: index,
    });
  };
  const detailsResponseLoad = (status, data) => {
    //console.log(data);

    data.map((item, key) => {
      item.dateFormatted = moment(item.date).format('DD/MMM/YYYY');

      switch (item.type) {
        case 'Customer':
          if (item.status == 'Approved') {
            item.debitFormatted = (
              <a href={item.idOrder} onClick={handleSelectDetail(item)}>
                {numberFormatCommaTwoFraction(item.amount)}
              </a>
            );
            item.creditFormatted = '';
            item.entry = 'Redemption of Supplies';
          } else if (item.status == 'Dennied') {
            item.creditFormatted = numberFormatCommaTwoFraction(item.amount);
            item.entry = 'Reversed transaction';
          }
          break;
        case 'EndUser':
          if (item.status == 'Approved') {
            item.creditFormatted = numberFormatCommaTwoFraction(item.amount);
            item.debitFormatted = '';
            item.entry = '#' + item.idOrder + ' Landing Cost ' + item.name;
          } else if (item.status == 'Dennied') {
            item.debitFormatted = numberFormatCommaTwoFraction(item.amount);
            item.creditFormatted = '';
            item.entry = '#' + item.idOrder + ' Dennied ' + item.name;
          }
          break;
        case 'Adjustment':
          if (item.amount < 0) {
            item.debitFormatted = numberFormatCommaTwoFraction(item.amount);
          } else {
            item.creditFormatted = numberFormatCommaTwoFraction(item.amount);
          }
          item.entry = item.name;
          break;
        default:
          item.debitFormatted = numberFormatCommaTwoFraction(item.amount);
          item.creditFormatted = numberFormatCommaTwoFraction(item.amount);
          item.entry = item.idOrder + ' ' + item.name + ' ';
          break;
      }
    });

    //setDataResponse(data === undefined ? [] : data);
    setTableDetailsData(data === undefined ? [] : data);
    //console.log(dataResponse);
    setIsLoadingDetails(false);
  };
  useEffect(() => {
    pagedDetailsData = filteredDetailsData.slice(
      (currentDetailsPage - 1) * pageSize,
      (currentDetailsPage - 1) * pageSize + pageSize
    );
    //console.log(pagedDetailsData);
  }, [tableDetailsData]);
  const handleSelectMonth = (index) => (event) => {
    event.preventDefault();
    //console.log(index);
    //console.log(event);
    setIsLoadingDetails(true);
    connectApi
      .get(
        'api/Channels/customer/compensationStatement/details/',
        {
          params: {
            customerId: index.idCustomer,
            date: index.month,
          },
        },
        detailsResponseLoad
      )
      .catch((error) => {
        console.log(error);
        setIsLoadingDetails(false);

        Swal.fire(
          'Error ' + error?.response?.status,
          error?.response?.data,
          'error'
        );
      });
  };

  const handlePageChange = (page) => setCurrentPage(page);
  const handleDetailsPageChange = (page) => setCurrentDetailsPage(page);

  const handleOnColumnReorder = (newOrder) => {
    setOrder(newOrder);
  };
  const handleOnColumnDetailsReorder = (newOrder) => {
    setOrderDetails(newOrder);
  };

  const filteredData = filterSort(
    tableData,
    //{ customerName, endUserName, serviceArea },
    {},
    orderBy,
    orderType
  );

  const filteredDetailsData = filterSort(
    tableDetailsData,
    //{ customerName, endUserName, serviceArea },
    {},
    orderByDetails,
    orderTypeDetails
  );

  function filterSort(array, filters, orderBy, orderType) {
    let arrayFiltered = array;
    // filter
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter =
        typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();

          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });

    // sort
    return arrayFiltered.sort((a, b) => {
      const value =
        orderType === 'descending'
          ? descendingComparator(a, b, orderBy)
          : -descendingComparator(a, b, orderBy);

      return value;
    });
  }

  function descendingComparator(a, b, orderBy) {
    let aSort =
      typeof a[orderBy] === 'object'
        ? typeof a[orderBy] === typeof (<a />)
          ? a[orderBy].props.href.toString().toUpperCase()
          : a[orderBy].props.label.toString().toUpperCase()
        : a[orderBy].toString().toUpperCase();
    //const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    let bSort =
      typeof b[orderBy] === 'object'
        ? typeof b[orderBy] === typeof (<a />)
          ? b[orderBy].props.href.toString().toUpperCase()
          : b[orderBy].props.label.toString().toUpperCase()
        : b[orderBy].toString().toUpperCase();
    //const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();

    if (orderBy.includes('Formatted')) {
      const orderByFormatted = orderBy.replace('Formatted', '');
      aSort = a[orderByFormatted];
      bSort = b[orderByFormatted];
    }

    if (bSort < aSort) {
      return -1;
    }
    if (bSort > aSort) {
      return 1;
    }
    return 0;
  }

  let pagedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );
  let pagedDetailsData = filteredDetailsData.slice(
    (currentDetailsPage - 1) * pageSize,
    (currentDetailsPage - 1) * pageSize + pageSize
  );
  useEffect(() => {
    // console.log(customerName);
    pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    //}, [customerName, endUserName, serviceArea]);
  }, []);

  const handleSort = (_, { id, type }) => {
    setOrderBy(id);
    setOrderType(type);
  };
  const handleDetailsSort = (_, { id, type }) => {
    setOrderByDetails(id);
    setOrderTypeDetails(type);
  };

  return (
    <div>
      <br />
      {RenderChannelsList()}

      <div>
        <br />
        <div
          style={{
            backgroundColor: '#f2f2f2',
            padding: '0.5%',
          }}
        >
          <div className="card-deck mb-2 container">
            <div className="card mb-2 box-shadow" style={{ maxWidth: '370px' }}>
              <div className="card-header text-center">
                <h4><Trans i18nKey='statement' /></h4>
              </div>
              <div className="card-body">
                <Table
                  showFilters
                  columnReorder
                  columns={configSatement}
                  data={pagedData}
                  onColumnReorder={handleOnColumnReorder}
                  onSort={handleSort}
                  loading={isLoading}
                  preferences={{
                    defaultOrder: configSatement.map((c) => c.id),
                    order,
                    sortBy: {
                      id: orderBy,
                      type: orderType,
                    },
                  }}
                  pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                  }}
                  css={{
                    'tr > td:nth-of-type(2)': {
                      textAlign: 'right',
                    },
                    'tr > td:nth-of-type(3)': {
                      textAlign: 'right',
                    },
                  }}
                ></Table>
              </div>
            </div>{' '}
            <div className="card mb-2 box-shadow">
              <div className="card-header text-center">
                <h4><Trans i18nKey='details' /></h4>
              </div>
              <div className="card-body">
                <Table
                  showFilters
                  columnReorder
                  columns={configDetails}
                  data={pagedDetailsData}
                  onColumnReorder={handleOnColumnDetailsReorder}
                  onSort={handleDetailsSort}
                  loading={isLoadingDetails}
                  preferences={{
                    defaultOrder: configDetails.map((c) => c.id),
                    order: orderDetails,
                    sortBy: {
                      id: orderByDetails,
                      type: orderTypeDetails,
                    },
                  }}
                  pagination={{
                    currentPage: currentDetailsPage,
                    onPageChange: handleDetailsPageChange,
                    pageSize,
                    totalItems: filteredDetailsData.length,
                  }}
                  css={{
                    'tr > td:nth-of-type(3)': {
                      textAlign: 'right',
                    },
                    'tr > td:nth-of-type(4)': {
                      textAlign: 'right',
                    },
                  }}
                ></Table>
                <br />
                <Button
                  leadingIcon={<IconClipboard />}
                  onClick={() => handleRedeemCompensation()}
                  disabled={channelSelected == ''}
                  style={{ marginBottom: '12px' }}
                  loading={isLoading}
                >
                  <Trans i18nKey='redeem' />
                </Button>
                {showOrderInProgressAlert ? (
                  <InlineNotification
                    title={<Trans i18nKey='orderInProgressAlert' />}
                    type="warning"
                    onClose={() => setShowOrderInProgressAlert(false)}
                  />
                ) : ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default ChannelRedeemStatements;
